import { Component } from '@angular/core';

@Component({
  selector: 'app-who-are-we',
  templateUrl: './who-are-we.component.html',
  styleUrl: './who-are-we.component.scss'
})
export class WhoAreWeComponent {

}
